<template>
    <div class="footer-unfixed">
        <span>
            Powered By <a><img src="@/assets/images/arrowlogo.png" alt="#"></a>
        </span>
    </div>
</template>
<script>
export default {
    name: "footer"
}
</script>
<style lang="scss">
@import "@/assets/css/global.scss";
.footer-unfixed {
    direction: ltr;
    height: 65px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid rgba(255, 255, 255, 0.13);
    span {
        @include apply-font($inter, 500, 11px, #4C667A);
        a { 
            margin-left: 20px;
            img {
                cursor: pointer;
            }
        }
    }
}

</style>